import React, { useMemo } from 'react';

import { Label, RowContainer, StyledTextArea } from './styles';
import DataRowNote from '../DataRowNote/DataRowNote';

interface DataRowProps {
  label: string;
  value: string | number | string[] | undefined;
  note?: string;
  editable?: boolean;
  onChange?: () => void;
}

const DataRow: React.FC<DataRowProps> = ({
  label,
  value,
  note,
  editable = false,
  onChange,
}) => {
  const displayValue = useMemo(() => {
    if (Array.isArray(value)) {
      const joined = value.join('\n');
      return note ? `${joined}*` : (joined ?? '');
    }

    return note ? `${value}*` : (value ?? '');
  }, [value, note]);

  return (
    <>
      <RowContainer>
        <Label>{label}:</Label>
        <StyledTextArea
          value={displayValue}
          readOnly={!editable}
          editable={editable}
          onChange={onChange}
        />
      </RowContainer>
      {note && <DataRowNote value={note} />}
    </>
  );
};

export default DataRow;
